/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseClient } from '../base-client';
import { DmsApiConfiguration } from '../dms-api-configuration';
import { DmsResponse } from '../dms-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DmsActivityModel } from '../models/dms-activity-model';
import { DmsActivityQuery } from '../models/dms-activity-query';

@Injectable({
  providedIn: 'root',
})
export class DmsSystemClient extends BaseClient {
  constructor(
    config: DmsApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verifyAccess
   */
  static readonly VerifyAccessPath = '/api/System';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyAccess()` instead.
   *
   * This method doesn't expect any response body
   */
  verifyAccess$Response(params?: {

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.VerifyAccessPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `verifyAccess$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  verifyAccess(params?: {

  }): Observable<void> {

    return this.verifyAccess$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation copyContainer
   */
  static readonly CopyContainerPath = '/api/System/azure/{source}/copy/{target}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyContainer()` instead.
   *
   * This method doesn't expect any response body
   */
  copyContainer$Response(params: {
    source: string;
    target: string;

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.CopyContainerPath, 'get');
    if (params) {

      rb.path('source', params.source);
      rb.path('target', params.target);

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `copyContainer$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  copyContainer(params: {
    source: string;
    target: string;

  }): Observable<void> {

    return this.copyContainer$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getActivity
   */
  static readonly GetActivityPath = '/api/System/activity';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivity()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  getActivity$Response(params?: {

    body?: DmsActivityQuery
  }): Observable<DmsResponse<Array<DmsActivityModel>>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.GetActivityPath, 'post');
    if (params) {


      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<Array<DmsActivityModel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getActivity$Response()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  getActivity(params?: {

    body?: DmsActivityQuery
  }): Observable<Array<DmsActivityModel>> {

    return this.getActivity$Response(params).pipe(
      map((r: DmsResponse<Array<DmsActivityModel>>) => r.body as Array<DmsActivityModel>)
    );
  }

  /**
   * Path part for operation getSqlUser
   */
  static readonly GetSqlUserPath = '/api/System/data/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSqlUser$Plain()` instead.
   *
   * This method doesn't expect any response body
   */
  getSqlUser$Plain$Response(params?: {

  }): Observable<DmsResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.GetSqlUserPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSqlUser$Plain$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getSqlUser$Plain(params?: {

  }): Observable<string> {

    return this.getSqlUser$Plain$Response(params).pipe(
      map((r: DmsResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSqlUser$Json()` instead.
   *
   * This method doesn't expect any response body
   */
  getSqlUser$Json$Response(params?: {

  }): Observable<DmsResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.GetSqlUserPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSqlUser$Json$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getSqlUser$Json(params?: {

  }): Observable<string> {

    return this.getSqlUser$Json$Response(params).pipe(
      map((r: DmsResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation transferData
   */
  static readonly TransferDataPath = '/api/System/data/copy/{sourceDb}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transferData()` instead.
   *
   * This method doesn't expect any response body
   */
  transferData$Response(params: {
    sourceDb: string;

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.TransferDataPath, 'get');
    if (params) {

      rb.path('sourceDb', params.sourceDb);

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `transferData$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  transferData(params: {
    sourceDb: string;

  }): Observable<void> {

    return this.transferData$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation clearAllTables
   */
  static readonly ClearAllTablesPath = '/api/System/data/clear/tables';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clearAllTables()` instead.
   *
   * This method doesn't expect any response body
   */
  clearAllTables$Response(params?: {

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.ClearAllTablesPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clearAllTables$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  clearAllTables(params?: {

  }): Observable<void> {

    return this.clearAllTables$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation clearAllData
   */
  static readonly ClearAllDataPath = '/api/System/data/clear/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clearAllData()` instead.
   *
   * This method doesn't expect any response body
   */
  clearAllData$Response(params?: {

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsSystemClient.ClearAllDataPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clearAllData$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  clearAllData(params?: {

  }): Observable<void> {

    return this.clearAllData$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

}
